import 'virtual:platform-styles'
import 'swiper/css'
import 'swiper/css/grid'
import 'swiper/css/free-mode'
import 'vue-final-modal/style.css'
import { createApp, markRaw } from 'vue'
import App from './App.vue'
import bootMain from './boot/main.js'
import { scheduleLazySentryInit } from './boot/sentry-scheduler'
import createRouter from './router/index.js'
import createStore from './stores/index.js'

const app = createApp(App)
app.config.performance = true

const store = typeof createStore === 'function' ? await createStore({}) : createStore
app.use(store)

const router = markRaw(typeof createRouter === 'function' ? await createRouter({ store }) : createRouter)

store.use(({ store: activeStore }) => {
  activeStore.router = router
})

const urlPath = window.location.href.replace(window.location.origin, '')
let routeTo = null

try {
  routeTo = await bootMain({
    app,
    router,
    store,
    ssrContext: null,
    urlPath,
    publicPath: import.meta.env.BASE_URL,
  })
} catch (err) {
  console.error('[Vite] boot error:', err)
}

app.use(router)

if (routeTo) {
  router.replace(routeTo).catch((e) => {
    console.error(e)
  })
}

app.mount('#q-app')

scheduleLazySentryInit({
  app,
  router,
})
